// ** MUI Imports
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { styled } from "@mui/material/styles";

// ** Icons Imports
import MenuIcon from "mdi-material-ui/Menu";
import BellOutline from "mdi-material-ui/BellOutline";
import ChevronDown from "mdi-material-ui/ChevronDown";

// ** Components
import Autocomplete from "src/layouts/components/Autocomplete";
import ModeToggler from "src/@core/layouts/components/shared-components/ModeToggler";
import UserDropdown from "src/@core/layouts/components/shared-components/UserDropdown";
import LanguageDropdown from "src/@core/layouts/components/shared-components/LanguageDropdown";
import NotificationDropdown from "src/@core/layouts/components/shared-components/NotificationDropdown";
import TranslateIcon from '@mui/icons-material/Translate';
import logos from "../../../assets/images/LogoAi.svg"
// ** Assets
import UserIcon from "src/assets/images/user.png";
import { useNavigate } from "react-router-dom";

// ** Styled Components
const AppBarContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  // padding: theme.spacing(2, 3),
  padding: "30px",
  height: "80px",
  "& .app-bar-content": {
    backgroundColor: "#FFFFFF",
    borderRadius: "12px",
    padding: theme.spacing(2, 3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    position: "relative",
    width: "100%",
  },
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  [theme.breakpoints.down("sm")]: {
    gap: "6px",
  },
}));

const LogoIcon = styled(Box)({
  width: "32px",
  height: "32px",
  backgroundColor: "#66FF00",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    bottom: "0",
    right: "0",
    width: "8px",
    height: "8px",
    backgroundColor: "#2E8B57",
    borderRadius: "0 0 8px 0",
  },
  "&::after": {
    content: '""',
    width: "16px",
    height: "16px",
    background:
      "linear-gradient(45deg, transparent 40%, white 40%, white 60%, transparent 60%)",
    borderRadius: "2px",
  },
});

const LogoText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: "#2E8B57",
  fontSize: "18px",
  letterSpacing: "0.5px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
  },
}));

const RightSection = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "16px",
});

const NotificationButton = styled(IconButton)({
  width: "40px",
  height: "40px",
  backgroundColor: "#F0F0F0",
  borderRadius: "50%",
  "&:hover": {
    backgroundColor: "#E0E0E0",
  },
});

const UserSection = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  cursor: "pointer",
  padding: "4px 8px",
  borderRadius: "20px",
  "&:hover": {
    backgroundColor: "#F5F5F5",
  },
});

const HamburgerButton = styled(IconButton)(({ theme }) => ({
  width: "40px",
  height: "40px",
  backgroundColor: "#F0F0F0",
  borderRadius: "50%",
  marginRight: "16px",
  "&:hover": {
    backgroundColor: "#E0E0E0",
  },
  [theme.breakpoints.down("sm")]: {
    width: "36px",
    height: "36px",
    marginRight: "12px",
  },
}));

const AppBarContent = (props) => {
  // ** Props
  const { hidden, settings, saveSettings, toggleNavVisibility } = props;
  const navigate = useNavigate();
  return (
    <AppBarContainer>
      <Box className="app-bar-content">
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {/* Hamburger Menu Icon - Only show on mobile */}
          {hidden && (
            <HamburgerButton
              color="inherit"
              onClick={toggleNavVisibility}
              aria-label="open navigation menu"
            >
              <MenuIcon style={{ color: "#666666" }} />
            </HamburgerButton>
          )}
          {!hidden && (
            <img src={logos} alt="logo" onClick={() => navigate("/")} />
          )}
        </Box>

        <RightSection>
          {/* <LanguageDropdown settings={settings} saveSettings={saveSettings} /> */}
          {/* <NotificationDropdown settings={settings} /> */}
          <UserSection>
            <UserDropdown settings={settings} />
            <ChevronDown style={{ color: "#808080", fontSize: "20px" }} />
          </UserSection>
        </RightSection>
      </Box>
    </AppBarContainer>
  );
};

export default AppBarContent;
